'use strict';

export const ASSET_CLASS_NAME = 'AssetDomain';
export const ASSET_COLLECTION = 'assets';

export function toStringStatic(data) {
  return data ? data.name || data.identifier : null;
}

/**
 * @typedef {Object} AssetDomain
 * @property {String} name
 * @property {String} identifier
 * @property {GeoJSON} geo
 * @property {DomainLink<OrganizationDomain>} organization
 * @property {DomainLink<UserDomain>} createdBy
 * @property {Date} dateCreated
 * @property {Date} lastUpdated
 * @property {DomainLink<FileDomain>} avatar
 * @property {Number} avc
 */

/**
 * AssetDomain angular provider
 * @constructor
 */
export function AssetDomainProvider() {
  return {
    $get: [
      '$injector',
      'FirebaseUtil',
      'AbstractDomainClass',
      'AvatarMixin',
      'OrgMixin',
      'FeedableMixin',
      '$filter',
      'FirebaseConnectionService',
      'fetchUtils',
      'restUtils',
      function (
        $injector,
        FirebaseUtil,
        AbstractDomainClass,
        AvatarMixin,
        OrgMixin,
        FeedableMixin,
        $filter,
        FirebaseConnectionService,
        fetchUtils,
        restUtils,
      ) {
        //console.log('Created  AssetDomain');
        const abbreviate = $filter('abbreviate');

        function AssetDomain(data) {
          AbstractDomainClass.call(this, AssetDomain, data);
        }

        AbstractDomainClass.__inheritFrom(AssetDomain, ASSET_CLASS_NAME, ASSET_COLLECTION);
        OrgMixin(AssetDomain);
        AvatarMixin(AssetDomain);
        FeedableMixin(AssetDomain);

        AssetDomain.$constraints.addConstraints({
          name: {type: 'string', nullable: true},
          identifier: {type: 'string', nullable: true},
          geo: {type: 'GeoJSON', nullable: true},
          organization: {type: 'Domain', domainClass: 'OrganizationDomain', links: 'assets', belongsTo: true},
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'},

          conversation: {type: 'LinkedDocument', domainClass: 'ConversationDomain', link: 'target'},

          assetProjects: {type: 'DomainCollection', domainClass: 'AssetProjectDomain', link: 'asset', belongsTo: true},
          dataTags: {type: 'DomainCollection', domainClass: 'DataTagLinkDomain'}
        });

        // more methods go here;

        AssetDomain.prototype.getAssetProject = getAssetProject;
        AssetDomain.prototype.getAvatarInitials = getAvatarInitials;
        AssetDomain.prototype.toString = toString;

        AssetDomain.prototype.create = restUtils.createProto(AssetDomain, {
          getBody: asset => ({
            name: asset.name,
            identifier: asset.identifier,
            geo: asset.geo ? JSON.stringify(asset.geo) : null,
            orgId: asset.organization && asset.organization.$id,
          }),
        });

        AssetDomain.prototype.update = restUtils.updateProto(AssetDomain);

        function getAssetProject(projectId) {
          const AssetProjectDomain = $injector.get('AssetProjectDomain');

          return AssetProjectDomain.$get(this.$id + projectId);
        }

        function toString() {
          return toStringStatic(this);
        }

        function getAvatarInitials() {
          return abbreviate(this.name ? this.name : this.identifier);
        }

        return AssetDomain;
      }]
  };
};



// WEBPACK FOOTER //
// ./src/js/assets/domain/AssetDomain.js